<template>
    <div role="status" aria-live="polite" class="flex" data-testid="chat-workday-review-loading">
        <BaseChip size="xs">
            <template #leading>
                <i class="bi bi-arrow-repeat inline-block animate-spin motion-reduce:animate-none" aria-hidden="true"></i>
            </template>
            {{ t("chat.workday.loadingReview") }}
        </BaseChip>
    </div>
</template>

<script setup lang="ts">
import BaseChip from "~vue/components/BaseChip.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
